export const GET_EXCEPTION_TYPES_REQUEST = 'GET_EXCEPTION_TYPES_REQUEST';
export const GET_EXCEPTION_TYPES_SUCCESS = 'GET_EXCEPTION_TYPES_SUCCESS';
export const GET_EXCEPTION_TYPES_FAILURE = 'GET_EXCEPTION_TYPES_FAILURE';

export const GET_EXCEPTION_LIST_REQUEST = 'GET_EXCEPTION_LIST_REQUEST';
export const GET_EXCEPTION_LIST_SUCCESS = 'GET_EXCEPTION_LIST_SUCCESS';
export const GET_EXCEPTION_LIST_FAILURE = 'GET_EXCEPTION_LIST_FAILURE';

export const GET_EXCEPTION_STATUSES_REQUEST = 'GET_EXCEPTION_STATUSES_REQUEST';
export const GET_EXCEPTION_STATUSES_SUCCESS = 'GET_EXCEPTION_STATUSES_SUCCESS';
export const GET_EXCEPTION_STATUSES_FAILURE = 'GET_EXCEPTION_STATUSES_FAILURE';

export const SET_EXCEPTION_REMEDIATION_REQUEST = 'SET_EXCEPTION_REMEDIATION_REQUEST';
export const SET_EXCEPTION_REMEDIATION_SUCCESS = 'SET_EXCEPTION_REMEDIATION_SUCCESS';
export const SET_EXCEPTION_REMEDIATION_FAILURE = 'SET_EXCEPTION_REMEDIATION_FAILURE';

export const GET_EXCEPTION_REMEDIATIONS_REQUEST = 'GET_EXCEPTION_REMEDIATIONS_REQUEST';
export const GET_EXCEPTION_REMEDIATIONS_SUCCESS = 'GET_EXCEPTION_REMEDIATIONS_SUCCESS';
export const GET_EXCEPTION_REMEDIATIONS_FAILURE = 'GET_EXCEPTION_REMEDIATIONS_FAILURE';

export const UPDATE_EXCEPTION_REMEDIATIONS_REQUEST = 'UPDATE_EXCEPTION_REMEDIATIONS_REQUEST';
export const UPDATE_EXCEPTION_REMEDIATIONS_SUCCESS = 'UPDATE_EXCEPTION_REMEDIATIONS_SUCCESS';
export const UPDATE_EXCEPTION_REMEDIATIONS_FAILURE = 'UPDATE_EXCEPTION_REMEDIATIONS_FAILURE';